import { render, staticRenderFns } from "./splashsync_categories.vue?vue&type=template&id=221a63aa"
import script from "./splashsync_categories.vue?vue&type=script&lang=js"
export * from "./splashsync_categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports